"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : MENU : FILTER : HOLDER : STYLES --------------- ++++++++++ */


var _default = {
  filterholder: {
    // animation comes from parent filtermenu
    display: 'flex',
    width: 'max-content',
    minHeight: (0, _index.pxToEm)(280),
    padding: (0, _index.replacePXinStringWithEM)('50px 80px 50px 50px'),
    position: 'absolute',
    top: (0, _index.pxToEm)(82),
    zIndex: '2',
    background: _index.theme.color.light.light.swatch,
    border: '1px solid rgb(236, 240, 247)',
    borderRadius: (0, _index.pxToEm)(5),
    boxShadow: (0, _index.replacePXinStringWithEM)('0px 4px 4px 0px rgba(0, 0, 0, 0.08)'),
    '& .inner': {
      '& .name-filters': {
        display: 'flex',
        flexWrap: 'wrap'
      }
    },
    '& .buttons': {
      display: 'flex',
      justifyContent: 'flex-start',
      marginTop: (0, _index.pxToEm)(30),
      '& .button': {
        width: (0, _index.pxToEm)(125)
      },
      '& .name-clearFilter': {
        marginRight: (0, _index.pxToEm)(10),
        background: _index.theme.color.neutral.light.swatch,
        color: _index.theme.color.primary.medium.swatch
      },
      '& .name-applyFilter': {
        color: _index.theme.color.primary.medium.contrast,
        background: _index.theme.color.primary.medium.swatch
      }
    },
    '& .carrot': {
      position: 'absolute',
      top: (0, _index.pxToEm)(-19),
      left: (0, _index.pxToEm)(55),
      transform: 'rotate(45deg)',
      background: _index.theme.color.light.light.swatch,
      height: (0, _index.pxToEm)(37),
      width: (0, _index.pxToEm)(37),
      border: '1px solid rgb(236, 240, 247)',
      borderBottom: '0px',
      borderRight: '0px'
    }
  }
};
exports.default = _default;